import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "../Common/Navbar";
import { fetchApi } from "../utlis/axios";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import backArrow from "../assets/back-button.png";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Banner from "../Common/Banner";
import Card from "./Card";
import { Footer } from "../Footer/Footer";

export const ProgramDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [program, setProgram] = useState(null);
  const [subProgram, setSubProgram] = useState(null);
  const [sortedSubProgram, setSortedSubProgram] = useState(null); // Add state for sorted sub-programs
  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState("All");
  const [loading, setLoading] = useState(false);

  const getSubProgram = async () => {
    try {
      setLoading(true);
      const result = await fetchApi.get(`sub-programs/`);
      if (result.status === 200) {
        setSubProgram(result?.data);
        setSortedSubProgram(result?.data); // Set the sortedSubProgram initially
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching program:", error);
      setIsLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getProgram = async () => {
    try {
      const result = await fetchApi.get(`programs/${id}`);
      if (result.status === 200) {
        setProgram(result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching program:", error);
      setIsLoading(false);
    }
  };

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  useEffect(() => {
    getSubProgram();
    getProgram();
  }, [id]);

  useEffect(() => {
    if (subProgram) {
      let sortedData = [...subProgram.results];
      if (currentTab === "Sort by budget") {
        sortedData.sort((a, b) => b.budget - a.budget);
      } else if (currentTab === "Sort by year") {
        sortedData.sort((a, b) => b.year - a.year);
      }
      setSortedSubProgram({ ...subProgram, results: sortedData });
    }
  }, [currentTab, subProgram]);

  return (
    <>
      <Header parent={'family'}/>
      <div
        style={{ backgroundColor: "#FFFFFF", minHeight: "100vh" }}
        className="Table_container"
      >
        <div className="Table_Section">
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <Lottie
                loop={true}
                animationData={Loader}
                style={{ width: "200px" }}
                className="auth-sidebar-video"
              />
            </div>
          ) : (
            <>
              {program?.thumbnail?.length === 0 ? (
                <div
                  style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="">
                    <b>No programs have been created.</b>
                  </div>
                </div>
              ) : (
                <>
                  <div className=" flex justify-center flex-col items-center">
                    <Swiper
                      className="w-full relative "
                      rewind={true}
                      loop={true}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                      grabCursor={true}
                      modules={[Autoplay]}
                    >
                      {program?.thumbnail?.map((item, index) => (
                        <SwiperSlide key={index}>
                          <div className="flex justify-center items-center h-full">
                            <img
                              className="w-full lg:h-[440px] md:h-96 h-64 "
                              src={item.file}
                              alt={`Slide ${index + 1}`}
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                      <div className="program_detail_slider z-40"></div>

                      <div className="absolute bottom-0 z-[70] text-white w-full xl:px-16 lg:px-12 md:px-8 sm:px-6 px-4" style={{background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.162917) 14.58%, rgba(0, 0, 0, 0.304263) 29.01%, rgba(0, 0, 0, 0.51) 50%, rgba(0, 0, 0, 0.755) 75%, #000000 100%)'}}>
                        <div className="max-w-screen-xl mx-auto md:py-10 py-[16px]">
                        <h1 className="md:text-3xl sm:text-xl text-lg md:pl-4 pl-[8px] border-l-[5px] border-primary-green mb-2 font-bold">
                          {program?.name}
                        </h1>
                        <p className="md:text-sm text-xs max-w-5xl">
                          {program?.description}
                        </p>
                        </div>
                      </div>
                    </Swiper>
                  </div>
                  <div className="mt-5 md:pb-8 pb-6 max-w-screen-xl mx-auto lg:px-16 md:px-8 sm:px-4 px-[16px]">
                    <h3 className="text-4xl font-bold">Related Programs</h3>

                    <div className="program_main w-full">
                      {loading && (
                        <div
                          style={{
                            position: "absolute",
                            top: "70%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 40,
                          }}
                        >
                          <Lottie
                            loop={true}
                            animationData={Loader}
                            style={{ width: "150px" }}
                          />
                        </div>
                      )}
                      {sortedSubProgram?.results?.length === 0 ? (
                        <div
                          style={{
                            height: "100vh",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          <div className="">
                            <b>No programs have been created.</b>
                          </div>
                        </div>
                      ) : (
                        <div className=" w-full sm:gap-10 gap-[24px] justify-start items-center grid grid-cols-1 md:grid-cols-2">
                          {sortedSubProgram?.results?.map((data, index) => (
                            <Card data={data} key={data?.id} />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
      <Footer/>
    </>
  );
};
